export enum SelectableActions {
  Duplicate = 'duplicate',
  Download = 'download',
}
